import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { validateLogin } from "../../services/validate-login";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import { ArrowRight, ArrowLeft } from "lucide-react";
import { getFormattedDate } from "../../utils/dateFormat";
import { loanSearchService, select2Service } from "../../services/ondcService";
import { v4 as uuidv4 } from "uuid";
import Loader from "../../components/common/Loader";

function Form() {
  const [accountAggregator, setAccountAggregator] = useState("finvu");
  const [loading, setLoading] = useState(false); // start false (page load)
  const navigate = useNavigate();

  const wait = (ms: number | undefined) => new Promise((resolve) => setTimeout(resolve, ms));
  
  useEffect(() => {
    async function getStep() {
      localStorage.setItem("step3TimeStamp",getFormattedDate())
      if(Number(localStorage.getItem("step")) >= 3){} else{ navigate("/personal-loan") }
    }
    getStep();
  }, []);

  const onClickEvent = async () => {
    localStorage.setItem("transaction_id", uuidv4());
    localStorage.setItem("step", "4")
    var userData = {
      loan_code: localStorage.getItem("loan_code"),
      transaction_id: localStorage.getItem("transaction_id"),
      message_id: localStorage.getItem("message_id"),
      device_info: "web_app",
      firstName: localStorage.getItem("firstName"),
      middleName: localStorage.getItem("middleName"),
      lastName: localStorage.getItem("lastName"),
      email: localStorage.getItem("email"),
      officialEmail: localStorage.getItem("professionalEmail"),
      dob: localStorage.getItem("dob"),
      gender: localStorage.getItem("gender"),
      pan: localStorage.getItem("pan"),
      contactNumber: localStorage.getItem("contactNumber"),
      employmentType: localStorage.getItem("employmentType"),
      income: localStorage.getItem("annualIncome"),
      companyName: localStorage.getItem("companyName"),
      companyType: localStorage.getItem("companyType"),
      addressL1: localStorage.getItem("addressL1"),
      addressL2: localStorage.getItem("addressL2"),
      city: localStorage.getItem("city"),
      state: localStorage.getItem("state"),
      pincode: localStorage.getItem("pincode"),
      endUse: localStorage.getItem("loanPurpose"),
      aa: accountAggregator,
      loan_amount: localStorage.getItem("loan_amount"),
      tenure: localStorage.getItem("tenure"),
      step0TimeStamp: localStorage.getItem("step0TimeStamp"),
      step1TimeStamp: localStorage.getItem("step1TimeStamp"),
      step2TimeStamp: localStorage.getItem("step2TimeStamp"),
      step3TimeStamp: localStorage.getItem("step3TimeStamp"),
      step4TimeStamp: getFormattedDate(),
    };

    try {
      setLoading(true); // show loader
      const response = await loanSearchService(userData);
      if (response.success) {
        navigate("/iagree");
      }else{
        console.log(response)
      }
    } catch (err) {
      console.error("Error fetching offers:", err);
    } finally {
      setLoading(false); // hide loader
    }
  };

  if (loading) {
    // full-screen loader while API is fetching
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#f5f9ff]">
        <Loader />
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-[#f5f9ff] px-4">
      {/* Hero Section */}
      <div className="flex flex-col md:flex-row max-w-5xl w-full bg-white rounded-2xl shadow-lg overflow-hidden">
        {/* Left side Image (fixed) */}
        <div className="basis-full md:basis-2/5 flex items-center justify-center p-6 bg-gray-50 md:h-[calc(100vh-100px)] md:sticky md:top-0">
          <img
            src="svg/img3.svg"
            alt="Working professional"
            className="w-full max-w-xs md:max-w-none object-contain"
          />
        </div>

        {/* Right side Form (scrollable) */}
        <div className="basis-full md:basis-3/5 flex flex-col p-8 bg-white relative md:h-[calc(100vh-100px)] md:overflow-y-auto">
          {/* Step Number */}
          <div className="absolute top-4 right-4 bg-blue-100 text-blue-700 text-xs font-semibold px-3 py-1 rounded-full shadow-sm">
            Step 4
          </div>
          <div className="flex-1 overflow-y-auto">
            <h2 className="text-xl font-semibold mb-6">
              PERSONAL LOAN APPLICATION
            </h2>
            <p className="text-sm text-gray-600 mb-4">
              Choose one of the RBI approved Account Aggregator to share your
              financial Information with Lenders
            </p>

            <div className="space-y-6">
              <label className="flex items-center gap-3 cursor-pointer">
                <input
                  type="radio"
                  name="profession"
                  value="finvu"
                  checked={accountAggregator === "finvu"}
                  onChange={(e) => setAccountAggregator(e.target.value)}
                  className="form-radio text-blue-600"
                />
                <span className="text-gray-800">Finvu</span>
              </label>
            </div>
          </div>

          {/* Buttons */}
          <div className="mt-6 flex gap-4">
            <button
              className="flex-1 bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition flex items-center justify-center gap-2"
              onClick={() => navigate("/employment-details")}
            >
              <ArrowLeft size={18} /> Back
            </button>

            <button
              className="flex-1 bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition flex items-center justify-center gap-2"
              onClick={onClickEvent}
            >
              Next <ArrowRight size={18} />
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default function Step4SelectAccountAggregator() {
  const navigate = useNavigate();

  useEffect(() => {
    validateLogin(navigate);
  }, [navigate]);

  return (
    <div className="flex flex-col h-screen overflow-y-auto">
      <div className="flex-shrink-0">
        <Header title="" />
      </div>

      {/* Main Content scrollable */}
      <main className="flex-1 overflow-y-auto">
          <Form />
      </main>
    </div>
  );
}
